<template>
  <b-row>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template #header>
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="m-0">Usuários EAD</h5>
              <div>
                <b-button
                  variant="info"
                  size="sm"
                  class="mr-2"
                  @click="$router.push('/ead/dashboard')"
                >
                  <i class="fa fa-arrow-left mr-1"></i>
                  Voltar
                </b-button>
                <b-button
                  variant="primary"
                  size="sm"
                  v-if="canManage"
                  @click="showCreateModal"
                >
                  <i class="fa fa-plus mr-1"></i>
                  Novo Usuário
                </b-button>
              </div>
            </div>
          </template>

          <b-card-body>
            <div class="table-container">
              <b-table
                :items="users"
                :fields="fields"
                :busy="loading"
                thead-class="users-header"
                borderless
                hover
                responsive
                show-empty
              >
                <template #table-busy>
                  <div class="text-center py-5">
                    <b-spinner></b-spinner>
                    <span class="ml-2">Carregando...</span>
                  </div>
                </template>

                <template #empty>
                  <div class="text-muted text-center py-5">
                    <i class="fas fa-check-circle fa-2x"></i>
                    <p class="mt-3">Nenhum usuário encontrado</p>
                  </div>
                </template>

                <template #cell(name)="data">
                  <span class="user-name">{{ data.value }}</span>
                </template>

                <template #cell(email)="data">
                  <span class="email-text">{{ data.value }}</span>
                </template>

                <template #cell(companyName)="data">
                  <span class="company-text">{{ data.value }}</span>
                </template>

                <template #cell(userType)="data">
                  <span class="type-text">{{
                    data.value === "aluno" ? "Aluno" : data.value
                  }}</span>
                </template>

                <template #cell(active)="data">
                  <b-badge :variant="data.value ? 'success' : 'warning'">
                    {{ data.value ? "Ativo" : "Em processamento" }}
                  </b-badge>
                </template>
              </b-table>
            </div>
          </b-card-body>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import { getEadUsers } from "@/api/ead";

export default {
  name: "GerenciarUsuarios",
  data() {
    return {
      users: [],
      loading: false,
      fields: [
        { key: "name", label: "Nome" },
        { key: "email", label: "Email" },
        { key: "userType", label: "Tipo" },
        { key: "companyName", label: "Empresa" },
        { key: "active", label: "Status" },
      ],
    };
  },
  computed: {
    canManage() {
      return this.$store.state.user?.profile?.permissions?.ead?.manage;
    },
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      this.loading = true;
      try {
        const response = await getEadUsers();
        this.users = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
        this.$bvToast.toast("Erro ao carregar usuários EAD", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.loading = false;
      }
    },
    showCreateModal() {
      this.$bvToast.toast("Funcionalidade em desenvolvimento", {
        title: "Informação",
        toastClass: "custom-toast custom-toast-info",
        variant: "light",
        solid: true,
        autoHideDelay: 5000,
        noCloseButton: false,
      });
    },
  },
};
</script>

<style scoped>
.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  overflow: hidden;
}

::v-deep .users-header th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
  border: 0;
  white-space: nowrap;
}

::v-deep .users-header th.sortable:hover {
  color: #0056b3;
}

::v-deep tbody tr {
  cursor: pointer;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s ease-in-out;
}

::v-deep tbody tr:hover {
  background-color: #e9ecef !important;
}

::v-deep tbody tr:last-of-type {
  border-bottom: none;
}

::v-deep tbody tr td {
  border-top: none;
  vertical-align: middle;
  padding: 0.85rem 0.75rem;
}

::v-deep .user-name {
  color: #007bff;
  font-weight: 500;
}

::v-deep .email-text,
::v-deep .company-text,
::v-deep .type-text {
  color: #6c757d;
}

/* Animação de transição */
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}
</style>
